import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  ADD_EMPLOYEE,
  UPDATE_EMPLOYEE,
  DELETE_EMPLOYEE,
} from "../types/employeeTypes";

import config from './../../config/api';
import axiosInstance from "../../config/axiosConfig";

const API_URL = config.backendUrl;


export const fetchEmployees = () => async (dispatch) => {
  dispatch({ type: FETCH_EMPLOYEES_REQUEST });
  try {
    const response = await axiosInstance.get(`${API_URL}/employees`); // Adjust API endpoint as needed
    dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_EMPLOYEES_FAILURE, payload: error.message });
  }
};

export const addEmployee = (employeeData) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/employees`, employeeData);
    dispatch({ type: ADD_EMPLOYEE, payload: response.data });
  } catch (error) {
    console.error("Error adding employee:", error);
  }
};

export const updateEmployee = (id, updatedData) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`/api/employees/${id}`, updatedData);
    dispatch({ type: UPDATE_EMPLOYEE, payload: response.data });
  } catch (error) {
    console.error("Error updating employee:", error);
  }
};

export const deleteEmployee = (id) => async (dispatch) => {
  try {
    await axiosInstance.delete(`/api/employees/${id}`);
    dispatch({ type: DELETE_EMPLOYEE, payload: id });
  } catch (error) {
    console.error("Error deleting employee:", error);
  }
};
